// Serviceable Pincodes Data extracted from Wiom_Prelaunch_Pincode_Serviceability_Master.xlsx
// This list contains all pincodes where Wiom will be available by 26th January 2026

export const SERVICEABLE_PINCODES = new Set([
  // Delhi
  "110001", "110002", "110003", "110005", "110006", "110007", "110008", "110009", "110010",
  "110011", "110012", "110013", "110014", "110015", "110016", "110017", "110018", "110019", "110020",
  "110021", "110022", "110023", "110024", "110025", "110026", "110027", "110028", "110029", "110030",
  "110031", "110032", "110033", "110034", "110035", "110036", "110037", "110038", "110039", "110040",
  "110041", "110042", "110043", "110044", "110045", "110046", "110047", "110048", "110049", "110051",
  "110052", "110053", "110054", "110055", "110056", "110057", "110058", "110059", "110060", "110061",
  "110062", "110063", "110064", "110065", "110066", "110067", "110068", "110069", "110070", "110071",
  "110072", "110073", "110074", "110075", "110076", "110077", "110078", "110080", "110081", "110082",
  "110083", "110084", "110085", "110086", "110087", "110088", "110089", "110090", "110091", "110092",
  "110093", "110094", "110095", "110096",
  // Gurugram, Haryana
  "122001", "122002", "122003", "122004", "122006", "122007", "122008", "122009", "122010",
  "122011", "122015", "122016", "122017", "122018", "122051",
  // Noida, UP
  "201301", "201302", "201303", "201304", "201305", "201306", "201307", "201308", "201309",
  // Greater Noida, UP
  "201310", "201318", "203201",
  // Faridabad, Haryana
  "121001", "121002", "121003", "121004", "121005", "121006", "121007",
  // Ghaziabad, UP
  "201001", "201002", "201003", "201004", "201005", "201009",
  // Meerut, Uttar Pradesh
  "250001", "250002", "250003", "250004", "250005",
  // Bijnor, Uttar Pradesh
  "246701", "246702", "246721",
  // Muzaffarnagar, Uttar Pradesh
  "251001", "251002", "251003", "251004",
  // Hapur, Uttar Pradesh
  "245101", "245304",
  // Modinagar, Uttar Pradesh
  "201204",
  // Agra, Uttar Pradesh
  "282001", "282002", "282003", "282004", "282005", "282006", "282007", "282008", "282009", "282010",
  // Aligarh, Uttar Pradesh
  "202001", "202002",
  // Mathura, Uttar Pradesh
  "281001", "281002", "281003", "281004",
  // Firozabad, Uttar Pradesh
  "283203", "283204", "283205",
  // Shikohabad, Uttar Pradesh
  "283135",
  // Bareilly, Uttar Pradesh
  "243001", "243002", "243003", "243004", "243005", "243006",
  // Moradabad, Uttar Pradesh
  "244001", "244002", "244003",
  // Budaun, Uttar Pradesh
  "243601", "243602",
  // Lucknow, Uttar Pradesh
  "226001", "226002", "226003", "226004", "226005", "226006", "226007", "226008", "226009", "226010",
  "226011", "226012", "226013", "226014", "226015", "226016", "226017", "226018", "226019", "226020",
  "226021", "226022", "226023", "226024", "226025", "226026", "226027", "226028", "226029", "226030",
  // Prayagraj, Uttar Pradesh
  "211001", "211002", "211003", "211004", "211005", "211006", "211007", "211008", "211009", "211010",
  "211011", "211012",
  // Gorakhpur, Uttar Pradesh
  "273001", "273002", "273003", "273004", "273005", "273006", "273007", "273008", "273009", "273010"
]);

// Function to check if a pincode is serviceable
export const isPincodeServiceable = (pincode) => {
  return SERVICEABLE_PINCODES.has(pincode?.toString().trim());
};

